<div class="d-flex flex-column align-items-center" style="margin: 10px">
  <img src="./../../../../assets/images/icon/loading.gif" alt="" width="50">
  <!-- <h3>Đang tải...</h3> -->
</div>